import { useConfig } from '@cp/shared/config';
import React, { PropsWithChildren } from 'react';
import { MetricaExperimentsContext, MetricaExperimentsProvider, useExperimentsContext } from 'yandex-metrica-ab-react';
import { isBrowser } from '@cp/utils/browser';
import { useInjection } from '@cp/shared/di';
import { AB_SSR_VALUE } from 'src/shared/ab';

const useVarioqubId = () => {
  const config = useConfig();
  const counterId = config.get('YANDEX_METRIKA_COUNTER_ID');
  return isBrowser && counterId ? `metrika.${counterId}` : undefined;
};

const IsomorphicContext = (props: PropsWithChildren) => {
  const ssrValue = useInjection(AB_SSR_VALUE) || { ready: false, flags: {} };
  const upperContext = useExperimentsContext();
  return (
    <MetricaExperimentsContext.Provider value={upperContext.ready ? upperContext : ssrValue}>
      {props.children}
    </MetricaExperimentsContext.Provider>
  );
};

export const VarioqubProvider = (props: PropsWithChildren) => {
  const clientId = useVarioqubId();
  const value = useInjection(AB_SSR_VALUE) || { ready: false, flags: {} };
  return clientId ? (
    <MetricaExperimentsProvider clientId={clientId}>
      <IsomorphicContext>{props.children}</IsomorphicContext>
    </MetricaExperimentsProvider>
  ) : (
    <MetricaExperimentsContext.Provider value={value}>{props.children}</MetricaExperimentsContext.Provider>
  );
};
